/* eslint-disable filenames/match-exported */
import React, { useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import LoadingIndicator from "components/atomics/LoadingIndicator";
import translations from "translations";
import Props from "./index.d";
import Modal from "components/lbc-toolkit/molecules/Modal";
import { Typography } from "@material-ui/core";
import { closeOnUpdate } from "components/PagesCampusManagement/teilnehmer/StudentUpdate/recoilState";
import { useSetRecoilState } from "recoil";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles<Theme, Props>(
  (theme) =>
    createStyles({
      SubmitButton: {
        cursor: "pointer",
        height: "40px",
        alignItems: "center",
        appearance: "none",
        backgroundColor: (props) => (!props.disabled ? theme.colors.christineRed : theme.colors.lbcGrey),
        borderStyle: "none",
        // borderRadius: "4px",
        color: (props) => (!props.disabled ? theme.colors.tWhite : theme.colors.grey400),
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        width: "217px",
      },
      title: {
        textTransform: "uppercase",
        boxSizing: "content-box",
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: 15,
        lineHeight: "26px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        letterSpacing: "0.46px",
      },
    }),
  { name: "Button" }
);

const SubmitButton: React.FC<Props> = (props) => {
  const {
    title,
    variant,
    confirm,
    disabled,
    buttonLabel,
    data: { setAndSave },
  } = props;
  const classes = useStyles(props);
  const [submit, setSubmit] = useState(false);
  const setShouldClose = useSetRecoilState(closeOnUpdate);
  const history = useHistory();

  const setAndSaveInner2 = (value: boolean) => {
    setShouldClose(true);
    setAndSave(value);
  };

  const setAndSaveConfirmable = () => {
    if (!confirm) {
      setAndSaveInner2(true);
    } else {
      setSubmit(true);
    }
  };

  const submitAfterConfirm = () => {
    setSubmit(false);
    setAndSaveInner2(true);
    history.goBack();
  };

  return (
    <>
      <Modal
        open={!!submit}
        onClose={() => setSubmit(false)}
        onCancel={() => setSubmit(false)}
        onConfirm={submitAfterConfirm}
        title={title}
      >
        <Typography variant="h4">{translations.globals.popupMessages.saveData}</Typography>
      </Modal>
      <div className={classes.root}>
        <button className={classes.SubmitButton} disabled={disabled} onClick={setAndSaveConfirmable}>
          <span className={classes.title}>{buttonLabel ?? translations.globals.terms.submit}</span>
        </button>
      </div>
    </>
  );
};

export default SubmitButton;
